module.exports = __webpack_public_path__ + "img/svg/faq-separator-mobile.e90069c58c6b741f18e3ebe036c96d27.svg";